import * as types from './types'

export default {
    [types.USUARIO_INCLUIR_SUCCESS] (state, payload) {
        const item = state.lista.find(p => p.id == payload.id)
        const isNew = item === undefined
        const index = isNew ? 0 : state.lista.findIndex(p => p == item)
        const replace = isNew ? 0 : 1

        state.lista.splice(index, replace, { ...item, ...payload })
    },

    [types.USUARIO_REMOVER_SUCCESS] (state, payload) {
        state.lista = state.lista.filter(p => p.id !== payload)
    }
}